module.exports = __webpack_public_path__ + "static/Logo-and-title-0659cdea06ddc1e05f722a6fd97dec55.png";